import { NgModule } from '@angular/core';
import { ProfilePicComponent } from '@flipto/shared/src/lib/components/images/profile-pic/profile-pic.component';
import { SharedDirectivesModule } from '@flipto/shared/src/lib/directives/shared-directives.module';

@NgModule({
    imports: [
        ProfilePicComponent,
        SharedDirectivesModule
    ],
    exports: [
        ProfilePicComponent,
        SharedDirectivesModule
    ]
})
export class SharedComponentsModule {
}
